import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 0c4 6 10 12 16 16-6 4-12 10-16 16-4-6-10-12-16-16C6 12 12 6 16 0m0 4.115C12.67 8.475 8.476 12.669 4.115 16 8.475 19.33 12.67 23.523 16 27.884c3.33-4.36 7.524-8.554 11.884-11.884C23.524 12.67 19.33 8.475 16 4.115"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
HyperstarOutlinedSize32Glyph.displayName = 'HyperstarOutlinedSize32Glyph';
